var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('container', [_c('div', {
    staticClass: "h-screen-80 flex flex-column items-center justify-center"
  }, [_c('icon', {
    staticClass: "justify-center",
    attrs: {
      "icon": _vm.$icons.warning,
      "x-large": "",
      "prominent": "",
      "color": "warning"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "text-center mt-20"
  }, [_vm._v(_vm._s(_vm.errorTitle))]), _vm._v(" "), _c('p', {
    staticClass: "text-center mb-0 w-full",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }), _vm._v(" "), _vm.isOffline ? _c('wrapper', {
    staticClass: "mt-24",
    attrs: {
      "stretch": ""
    }
  }, [_c('btn', {
    attrs: {
      "depressed": ""
    },
    on: {
      "click": _vm.reloadPage
    }
  }, [_c('icon', {
    attrs: {
      "icon": _vm.$icons.refresh
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('action.refresh')))])], 1)], 1) : _vm.statusCode > 399 && _vm.statusCode < 500 ? _c('wrapper', {
    staticClass: "mt-48",
    attrs: {
      "grow": "",
      "center": ""
    }
  }, [_c('btn', {
    on: {
      "click": function ($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_c('icon', {
    attrs: {
      "icon": _vm.$icons.back
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('action.back')))])], 1)], 1) : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }